import styled from "styled-components";
import { useState, useEffect } from "react";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import request from "../../../../../api/request";
import { updateObject } from "../../../../../utils/object";
import { NotificationManager } from 'react-notifications';

const StyledSuspenseAccountsSettings = styled.div`
    margin-left: 30px;
`;

const SettingsBoard = styled.div`
    background-color: white;
    width: 755px;
    box-sizing: border-box;
    min-height: 400px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function SuspenseAccountsSettings(props) {

    const [isSaving, setIsSaving] = useState(false);
    const [branchOpeningAccount, setBranchOpeningAccount] = useState('');
    const [festivalOpeningAccount, setFestivalOpeningAccount] = useState('');

    const onSaveChanges = async () => {
        setIsSaving(true);
        let saveData = {
            BranchOBSuspense: branchOpeningAccount.length ? branchOpeningAccount : null,
            FestivalOBSuspense: festivalOpeningAccount.length ? festivalOpeningAccount : null
        }
        const resp = (await request('database', 'saveSettings', [saveData]));
        if (resp.ok) {
            updateObject(props.settings, saveData);
            props.setSettings(props.settings);
            NotificationManager.success('Suspense account settings saved');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    useEffect(() => {
        props.setPageTitle('Suspense accounts');
        setBranchOpeningAccount(props.settings.BranchOBSuspense || '');
        setFestivalOpeningAccount(props.settings.FestivalOBSuspense || '');
    }, [])

    return (
        <StyledSuspenseAccountsSettings>
            <SettingsBoard>
                <Title>Opening balances suspense accounts</Title>
                <div style={{paddingTop: 5}}>
                <FormStringInput label='Branch opening balance suspense account' placeholder='sampletest' value={branchOpeningAccount} onChange={setBranchOpeningAccount} inputStyle={{width:250}}></FormStringInput>
                </div>
                <FormStringInput label='Festival opening balance suspense account' placeholder='festivalsample' value={festivalOpeningAccount} onChange={setFestivalOpeningAccount} inputStyle={{width:250}}></FormStringInput>
            </SettingsBoard>
            <div style={{float: 'right'}}><PrimaryButton caption='Save changes' isLoading={isSaving} onClick={onSaveChanges}></PrimaryButton></div>
        </StyledSuspenseAccountsSettings>
    )
}

export default SuspenseAccountsSettings;